import {
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import React, { useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom/dist';
import { navigateToDashboard } from '../../utils/navigation';

const DrawerComp = ({
  pages = [],
  isLoggedIn = false,
  loginText = 'Log In',
  signupText = 'Sign Up',
  onLogin,
  onSignup,
  onDashboardHome,
}) => {
  const navigate = useNavigate();
  const [openDrawer, setOpenDrawer] = useState(false);
  const closeDrawer = () => setOpenDrawer(false);
  const handleNavigation = (page) => {
    if (!page?.link) return;
    if (/^(https?:\/\/|mailto:|tel:)/i.test(page.link)) {
      window.location.href = page.link;
      return;
    }
    if (page.link === '/login' || page.link === '/createaccount' || page.link === '/register') {
      navigateToDashboard(page.link);
      return;
    }
    navigate(page.link);
  };
  return (
    <>
      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={closeDrawer}
      >
        <List sx={{ minWidth: 220, pt: 1 }}>
          {pages.map((page, index) => (
            <ListItemButton
              onClick={() => {
                closeDrawer();
                handleNavigation(page);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              key={index}
            >
              <ListItemIcon>
                <ListItemText
                  primary={page?.name || ''}
                  primaryTypographyProps={{
                    sx: { ...NavbarText, color: 'black' },
                  }}
                />
              </ListItemIcon>
            </ListItemButton>
          ))}
          <Divider sx={{ my: 1 }} />
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, px: 2, pb: 2 }}>
            {isLoggedIn ? (
              <Button
                fullWidth
                variant="contained"
                onClick={() => {
                  closeDrawer();
                  onDashboardHome?.();
                }}
                sx={authButtonSx}
              >
                Home
              </Button>
            ) : (
              <>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => {
                    closeDrawer();
                    onLogin?.();
                  }}
                  sx={authButtonSx}
                >
                  {loginText}
                </Button>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => {
                    closeDrawer();
                    onSignup?.();
                  }}
                  sx={authButtonSx}
                >
                  {signupText}
                </Button>
              </>
            )}
          </Box>
        </List>
      </Drawer>
      <IconButton
        sx={{ color: 'black', marginLeft: 'auto' }}
        onClick={() => setOpenDrawer(!openDrawer)}
      >
        <MenuIcon sx={{ fontSize: '3rem' }} />
      </IconButton>
    </>
  );
};

export default DrawerComp;
const authButtonSx = {
  textTransform: 'none',
  fontFamily: 'Poppins',
  fontWeight: 600,
  fontSize: '14px',
  borderRadius: '10px',
  backgroundColor: '#445fd2',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#eef7ff',
    color: '#0053ad',
  },
};
const NavbarText = {
  marginLeft: '16px',
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '18px',
  display: 'flex',
  alignItems: 'center',
  textAlign: 'right',
  color: '#252525',
  cursor: 'pointer',
};
